import { AiOutlineLoading3Quarters } from "react-icons/ai";

export default function Loading({ size = 20, className = "" }) {
    return (
        <AiOutlineLoading3Quarters
            size={size}
            className={`animate-spin ${className}`}
        />
    );
}